<h2>{{ 'T4.Settings.EmailTemplate.lblEmailTemplate' | translate : 'Email Template' }}</h2>
<t4-container>
  <h2>{{ 'T4.Settings.EmailTemplate.lblEmailTTemplateSettings' | translate : 'Settings' }}</h2>
  <div class="row" *ngIf="emailTypes">
    <mat-form-field style="max-width:400px;">
      <mat-label>{{ 'T4.Settings.EmailTemplate.lblEmailTypes' | translate:'Email Type'}}</mat-label>
      <mat-select (selectionChange)="onEmailTypeChange($event)">
        <mat-option [value]="k" *ngFor="let k of emailTypes">{{k}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="row" *ngIf="filteredKeys">
    <mat-form-field style="max-width:400px;">
      <mat-label>{{ 'T4.Settings.EmailTemplate.lblKeys' | translate:'Keys'}}</mat-label>
      <mat-select (selectionChange)="onKeyChange($event)">
        <mat-option [value]="k" *ngFor="let k of filteredKeys">{{k | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</t4-container>
<t4-container *ngIf="filteredFriendlyNames">
  <h2>{{ 'T4.Settings.EmailTemplate.lblEmailTTemplateEditor' | translate : 'Editor' }}</h2>
  <mat-tab-group (selectedTabChange)="onTabChange($event)" contentPreserve mat-stretch-tabs>
      <mat-tab class="et-mat-tab-body" *ngFor="let fn of filteredFriendlyNames; let i = index " [label]="fn.FriendlyName || 'Default'">
        <div class="row">
          <div class="col-md-8">
            <mat-tab-group>
              <mat-tab label="Preview" *ngIf="fn.Format != 0">
                <div class="NgxEditor__Wrapper" *ngIf="selectedIndex == i" style="margin-top: 10px;">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
                  <ngx-editor [editor]="editor" [(ngModel)]="editorContent" [disabled]="false"></ngx-editor>
                </div>
              </mat-tab>
              <mat-tab label="Code">
                <mat-form-field appearance="outline" style=" margin-top: 10px;">
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="editorContent">{{editorContent}}</textarea>
                </mat-form-field>
              </mat-tab>
            </mat-tab-group>
          </div>
          <div class="col-md-4 p-0" style="margin-top: 2rem;">
            <mat-form-field appearance="outline" style="margin: 10px; max-width: 400px;">
              <mat-label>{{ 'T4.Settings.EmailTemplate.txtFriendlyName' | translate : 'Friendly Name'}}</mat-label>
              <input id="txtFriendlyName"
                     autocomplete="off"
                     matInput [(ngModel)]="updatedFriendlyName">
              <mat-error>{{ 'T4.Settings.EmailTemplate.txtFriendlyName.txtFriendlyName' | translate : 'A name is required'}}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" style="margin: 10px; max-width: 400px;">
              <mat-label>{{ 'T4.Settings.EmailTemplate.Condition' | translate : 'Condition'}}</mat-label>
              <input id="txtCondition"
                     autocomplete="off"
                     matInput [(ngModel)]="updatedCondition">
              <mat-error>{{ 'T4.Settings.EmailTemplate.txtCondition.txtCondition_required' | translate : 'A Condition is required'}}</mat-error>
            </mat-form-field>
            <div class="row">
              <div class="et-button" style="margin-left:15px;">
                <button [disabled]="disabled" mat-flat-button color="primary" style="margin: 5px;" (click)="updateNewTemplate()">
                  {{'T4.Settings.EmailTemplate.btnUpdate' | translate : 'Update' }}
                </button>
              </div>
              <div class="et-button">
                <button [disabled]="disabled" mat-flat-button color="primary" style="margin: 5px; margin-right:10px;" (click)="removeNewTemplate()">
                  {{'T4.Settings.EmailTemplate.btnRemove' | translate : 'Remove' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="+">
        <form [formGroup]="form">
          <div class="row p-1">
            <div class="col-sm-8 p-0">
              <div [ngClass]="{'col-sm-6': showEditor}" class="col-sm-6 p-0">
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Content</mat-label>
                  <textarea matInput formControlName="newContent" [(ngModel)]="newContent" style="height: 500px;"></textarea>
                </mat-form-field>
              </div>
              <div class="col-sm-6" *ngIf="showEditor">
                <div class="NgxEditor__Wrapper" style="height:532px;width:100%; margin-top:5px;">
                  <ngx-editor-menu [editor]="newEditor" [toolbar]="toolbar"> </ngx-editor-menu>
                  <ngx-editor [editor]="newEditor" formControlName="newContent" [(ngModel)]="newContent" [placeholder]="'Type here...'"></ngx-editor>
                </div>
              </div>
            </div>
            <div class="col-sm-4 p-0">
              <mat-form-field appearance="outline" style="margin: 10px; max-width: 400px;">
                <mat-label>{{ 'T4.Settings.EmailTemplate.txtFriendlyName' | translate : 'Friendly Name'}}</mat-label>
                <input id="txtFriendlyName"
                       autocomplete="off"
                       matInput
                       formControlName="friendlyName">
                <mat-error>{{ 'T4.Settings.EmailTemplate.txtFriendlyName.txtFriendlyName' | translate : 'A name is required'}}</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" style="margin: 10px; max-width: 400px;">
                <mat-label>{{ 'T4.Settings.EmailTemplate.Condition' | translate : 'Condition'}}</mat-label>
                <input id="txtCondition"
                       autocomplete="off"
                       matInput
                       formControlName="condition">
                <mat-error>{{ 'T4.Settings.EmailTemplate.txtCondition.txtCondition_required' | translate : 'A Condition is required'}}</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" style="margin: 10px; max-width: 400px;">
                <mat-label>{{ 'T4.Settings.EmailTemplate.lblFormat' | translate:'Format'}}</mat-label>
                <mat-select formControlName="format" (selectionChange)="onFormatChange($event)">
                  <mat-option [value]="f.key" *ngFor="let f of contentFormats">{{f.value}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-dialog-actions class="d-flex justify-content-start">
                <div class="et-button">
                  <button mat-flat-button color="primary" style="margin: 10px;" (click)="saveNewTemplate()">
                    {{'T4.Settings.EmailTemplate.Save' | translate : 'Save' }}
                  </button>
                </div>
              </mat-dialog-actions>
            </div>
          </div>
        </form>
      </mat-tab>
</mat-tab-group>
</t4-container>
